/** Angular Imports */
import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";

/** rxjs Imports */
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

/** Environment Configuration */

/** Custom Services */
import { Logger } from "../logger/logger.service";
import { AlertService } from "../alert/alert.service";
import { environment } from "../../../environments/environment";
import { SweetAlertService } from "../../services/sweet-alert.service";

/** Initialize Logger */
const log = new Logger("ErrorHandlerInterceptor");

/**
 * Http Request interceptor to add a default error handler to requests.
 */
@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  /**
   * @param {AlertService} alertService Alert Service.
   */
  constructor(
    private alertService: AlertService,
    private sweetAlert: SweetAlertService
  ) { }

  /**
   * Intercepts a Http request and adds a default error handler.
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(request)
      .pipe(catchError((error) => this.handleError(error)));
  }

  /**
   * Error handler.
   */
  handleError(response: HttpErrorResponse): Observable<HttpEvent<any>> {
    log.debug("<<HttpResponse>>");
    log.debug(JSON.stringify(response));
    const status = response.status;
    let errorMessage = response.error.developerMessage || response.message;
    log.debug("<<ErrorMessage>>");
    log.debug(errorMessage);
    if (response.error.errors) {
      if (response.error.errors[0]) {
        errorMessage =
          response.error.errors[0].defaultUserMessage ||
          response.error.errors[0].developerMessage;
      }
    }

    if (!environment.production) {
      log.error(`Request Error: ${errorMessage}`);
    }
    log.debug("<<ErrorMessage>>" + status);

    if (status === 401) {
      this.alertService.alert({
        type: "AuthenticationError",
        message: "Invalid User Details. Please try again!",
      });
    } else if (
      status === 403 &&
      errorMessage === "The provided one time token is invalid"
    ) {
      this.alertService.alert({
        type: "InvalidToken",
        message: "Invalid Token. Please try again!",
      });
    } else if (status === 400) {
      this.alertService.alert({
        type: "BadRequest",
        message: "Invalid parameters were passed in the request!",
      });
    } else if (status === 403) {
      this.alertService.alert({
        type: "UnauthorizedRequest",
        message: errorMessage || "You are not authorized for this request!",
      });
    } else if (status === 404) {
      log.debug("<<ErrorMessage>>" + status);
      this.alertService.alert({
        type: "ResourceDoesNotExist",
        message: errorMessage || "Resource does not exist!",
      });
    } else if (status === 500) {
      this.alertService.alert({
        type: "InternalServerError",
        message: "Internal Server Error. Please try again later.",
      });
    } else {
      this.alertService.alert({
        type: "UnknownError",
        message: "Unknown Error. Please try again later.",
      });
    }
    // throw response;
    return throwError(() => response);
  }
}
